<div class="reading-page doc-page">
  <div id="head" class="section-header">
    <h2 class="section-title">Dock Town Privacy Policy</h2>
  </div>
  <app-policy-card [policyBody]="body">
    <!-- Body -->
    <ng-template #body>
      <div class="policy-content">
        <p><strong>Effective: 20 October 2026</strong></p>

        <p><strong>Who we are</strong></p>
        <p><a [routerLink]="URLS.plugins.macosDockTown">Dock Town</a> is made by <strong>Codigrate OÜ</strong>,
          registry code 16262630, Sepapaja tn 6, 15551 Tallinn, Estonia. You can reach us at
          <a [href]="'mailto:' + environmentCommon.company.email">{{ environmentCommon.company.email }}</a>.</p>

        <p><strong>No personal data</strong></p>
        <p>Dock Town collects no personal data. There is no account, no analytics, no advertising, no tracking and no
          third-party SDKs. The app makes no network requests of its own, and Codigrate receives nothing from it.</p>

        <p><strong>What the app reads on your Mac</strong></p>
        <p>To draw the town and the Activity page, Dock Town reads system readings (CPU, memory, network activity,
          battery and thermal state) and each app's CPU and memory use. This happens on your Mac only.</p>
        <p>To award coins, the app notes which app is in front and how long your Mac has been idle. App names are kept on
          your Mac for the day's reports and in a local log and summary. They never leave your Mac.</p>

        <p><strong>Calendar and notifications</strong></p>
        <p>Calendar access is optional. It is used only to show your next meeting: events are read on your Mac and never
          sent anywhere. Notifications are optional too, and are used for alerts.</p>

        <p><strong>Coding agents</strong></p>
        <p>Connecting Claude Code, Codex or Antigravity CLI is optional. You choose each agent's folder yourself in
          macOS's open panel (.claude, .codex or .gemini/antigravity-cli in your home folder), and Dock Town only reads
          it: from the logs the agent writes, it takes whether a session is working or done, when, and the session's
          project folder. Your prompts, the agents' answers and their tool calls are never read. Dock Town writes
          nothing into these folders, and nothing leaves your Mac. Disconnect in Settings, Agents ends the access.</p>

        <p><strong>Apple Intelligence</strong></p>
        <p>The app descriptions written by Apple Intelligence are generated on-device. Nothing is sent to Codigrate or
          anyone else.</p>

        <p><strong>Purchases</strong></p>
        <p>Purchases (premium towns, Town Pass and coin packs) are handled by Apple through the App Store, under Apple's
          terms and privacy policy. Codigrate never sees your payment details. The app checks its own App Store
          transactions on your Mac to open towns and add coins.</p>

        <p><strong>Where the app keeps its data</strong></p>
        <p>Your coin balance and the record of credited purchases are kept in your Mac's login Keychain, so that purchased
          coins survive a reinstall. The app's other data stays in its own folder on your Mac. Deleting the app removes
          its data; the Keychain item can be removed in Keychain Access.</p>

        <p><strong>Access, export and deletion</strong></p>
        <p>Because nothing is collected, there is nothing for Codigrate to access, export or delete. If you have any
          questions, write to us at
          <a [href]="'mailto:' + environmentCommon.company.email">{{ environmentCommon.company.email }}</a>.</p>

        <p><strong>Changes to this policy</strong></p>
        <p>If this policy changes, the new version will be posted on this page with a new effective date.</p>

        <p><strong>Terms of Use</strong></p>
        <p>Dock Town's Terms of Use are Apple's standard
          <a [href]="eulaUrl" target="_blank" rel="noopener">Licensed Application End User License Agreement</a>.</p>
      </div>
    </ng-template>
  </app-policy-card>
</div>
